import logoSrc from '../assets/logo.png';

interface UrawaIconProps {
  className?: string;
}

export function UrawaIcon({ className = 'h-8 w-8' }: UrawaIconProps) {
  return (
    <img
      src={logoSrc}
      alt="Urava"
      className={className}
      style={{ objectFit: 'contain' }}
    />
  );
}
